import { formatRange } from '@/filters/util'

function formatWeight (w) {
  return `${w} g`
}

export default function (t) {
  return formatRange(t, formatWeight)
}
